export const PlayerOverallStatusSkeleton = () => (
	<div className="flex flex-col gap-4">
		{Array.from({ length: 2 }).map((_, index) => (
			<div
				className="w-full max-w-[350px] animate-pulse rounded-xl border border-gray-300 sm:max-w-[400px]"
				key={`player_status_skeleton_${index}`}
			>
				<div className="flex items-center justify-between border-b border-gray-300 px-6 py-5">
					<div>
						<div className="h-5 w-32 rounded bg-gray-300"></div>
						<div className="mt-2 h-4 w-24 rounded bg-gray-200"></div>
					</div>
					<div className="size-8 bg-gray-200"></div>
				</div>

				<div className="flex flex-col gap-8 p-8 text-xl font-medium">
					{Array.from({ length: 5 }).map((_, subIndex) => (
						<div className="flex justify-between" key={`player_status_row_skeleton_${subIndex}`}>
							<div className="h-5 w-48 rounded bg-gray-300"></div>
							<div className="h-5 w-16 rounded bg-gray-300"></div>
						</div>
					))}
				</div>
			</div>
		))}
	</div>
);
